<template>
  <v-radio-group
    v-bind="this.$attrs"
    @change="$emit('change', type)"
    v-model="type"
    row
    class="shrink mt-0 pt-0 d-flex align-center"
    style="height: 100%"
    hide-details
  >
    <div style="width: 100%" class="d-flex align-center justify-space-between">
      <v-radio label="Tất cả" hide-details value="all"></v-radio>
      <v-radio label="Đúng giờ" hide-details value="present"></v-radio>
      <v-radio label="Đi muộn" hide-details value="invalidPresent"></v-radio>
    </div>
  </v-radio-group>
</template>

<script>
export default {
  data: () => ({
    type: ''
  }),
  props: {},
  created() {},
  watch: {},
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
